import { useEffect } from 'react'
import {
  initMetaPixel,
  trackPageView,
  trackViewContent,
} from '../utils/metaPixel'

/**
 * Boots the Meta Pixel and fires the landing's entry events:
 * - PageView: immediately after the pixel is initialized.
 * - ViewContent: once the page has finished loading (main content visible).
 *
 * Both are guarded at module level, so re-renders or StrictMode's
 * double-invoked effects cannot fire them twice.
 */
export function useMetaPixel(): void {
  useEffect(() => {
    initMetaPixel()
    trackPageView()

    if (document.readyState === 'complete') {
      trackViewContent()
      return
    }

    const onLoad = () => trackViewContent()
    window.addEventListener('load', onLoad, { once: true })
    return () => window.removeEventListener('load', onLoad)
  }, [])
}
